/** @format */

import {makeStyles, createStyles} from '@mui/styles';
import {Theme} from '@mui/material/styles';

export const useIssuesNewStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: 'flex',
      gap: theme.spacing(4),
      alignItems: 'center',
      justifyContent: 'space-between',

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    headerText: {
      color: '#F1F1F1',
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '30px',
      letterSpacing: '0.225px',
      flexShrink: 0,
    },
    downloadButtonContainer: {
      display: 'flex',
      gap: theme.spacing(4),

      [theme.breakpoints.down('md')]: {
        width: '100%',
        flexDirection: 'column',
      },
    },
    downloadButton: {
      flexShrink: 0,
      padding: theme.spacing(4, 8),
      borderRadius: theme.spacing(2),
      background: theme.palette.semantic_dark?.surface.surface1,
      boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
      color: theme.palette.semantic_dark?.surface.onSurface,
      fontSize: '14px',
      fontWeight: 400,
      '&:hover': {
        background: theme.palette.figma_gray_dark_2?.main,
      },
    },
    downloadButtonIcon: {
      width: 18,
      height: 18,
      marginRight: theme.spacing(2),
    },
    setSensorsButton: {
      width: '210px',
      minWidth: '132px',
      padding: theme.spacing(0, 2),
      flexShrink: 0,
      color: theme.palette.semantic_dark?.surface.onSurface,
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '16px',

      [theme.breakpoints.down('md')]: {
        width: 'auto',
        flexShrink: 1,
      },
    },
    setSensorBox: {
      height: '48px',
      display: 'flex',
      gap: theme.spacing(4),
      alignItems: 'center',
      borderRadius: theme.spacing(2.5),
      border: `1px solid ${theme.palette.success.main}`,
      paddingLeft: theme.spacing(4),

      [theme.breakpoints.down('md')]: {
        justifyContent: 'space-between',
      },
    },
    setSensorText: {
      color: '#F1F1F1',
      fontSize: '14px',
      width: '180px',

      [theme.breakpoints.down('md')]: {
        width: 'max-content',
      },
    },
    row: {
      flexGrow: 1,
    },
  }),
);
